// extracted by mini-css-extract-plugin
module.exports = {"button":"SearchFormSubmitButton_button__0_w1_"};